import * as React from 'react';
import { Link } from "react-router-dom";

import './Frontpage.css';

class Frontpage extends React.Component<{ baseUrl: string }, {}> {
  public render() {
    const marketingElementStyle = {
      backgroundImage: "url(" + this.props.baseUrl + "/img/hiiri.jpg)"
    };

    return (
      <React.Fragment>
        <div className="row">
          <div className="col">
            <div id="marketing" style={marketingElementStyle}>
              <div className="light-darkening">
                <div className="marketing-padder">
                  <h1 className="display-4">> Project risk analyser</h1>
                  <p className="lead">Better project management with scenario analysis and risk estimates.</p>
                  <hr className="my-4" />
                  <p>Project risk analyser helps project participants to make better decisions. Risk analyser models project scenarios,
                    estimates their success likelihood and gives concrete insight into how likely a given project is to succeed.
                  </p>

                  <p>
                  <Link to="/project/sample">Sample software project</Link> | <Link to="/project/lansimetro_four_cars">Sample infrastructure project</Link>
                  </p>
                  <a type="button" className="btn btn-primary" href="#why">Read more</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div id="why" className="boxed">
              <h2>Why?</h2>
              <p>Using project risk analyser has numerous benefits to project management. It helps to approach planning, budgeting
            and risk analysis with concrete number data, which is very often lacking when starting a project.</p>

              <h3>Mapping scenarios and thinking out B-plans</h3>
              <p>Main benefit of Project risk analyser is to map out the scenarios a particular project might encounter. When planning
                a project, it's very easy to estimate and budget just by imagining the best case scenario, where every tech decision
                works and business flow is correctly predicted on the first try.</p>
              <p>Project risk analyser helps with this bias by requiring project planners to consider a rough estimate for every
                major design decision success probability and to map alternative scenario in case of failure.</p>

              <h3>Probability range for project success</h3>
              <p><strong>"All models are wrong but some are useful."</strong> Having a rough estimate for project success expressed
          as probability helps to get a feel for how likely the project is going to reach it's goals. A low probability at initial
          design phase is usually an indicator for too optimistic plan. In that case revising expectations or design
          choices is usually a good idea.</p>
            </div>
          </div>
        </div>
      </React.Fragment >
    )
  }
}

export default Frontpage;


// WEBPACK FOOTER //
// ./src/components/frontpage/Frontpage.tsx